import { WidgetType } from '../../../types/api/ElementType';
import { useWidgetContext } from './WidgetContext';

export const getWidgetFrameId = (widgetType: WidgetType, uuid: string) => `widget-frame-${widgetType}-${uuid}`;
export const getWidgetHeaderId = (widgetType: WidgetType, uuid: string) => `widget-header-${widgetType}-${uuid}`;

export const useWidgetHeaderId = () => {
  const { widgetType, uuid } = useWidgetContext();
  return getWidgetHeaderId(widgetType, uuid);
};
